import axios from "./axios";
import { getCommonLoginToken, getUser } from "./useLocalStorageUser";

const getHeader = async (ourRequestToken = null) => {
	const user = await getUser();
	const header = user
		? {
				headers: {
					"Content-Type": "application/json",
					Authorization: `${user.token_type ?? "Bearer"} ${user.token}`,
				},
				cancelToken: ourRequestToken ? ourRequestToken : "",
		  }
		: { cancelToken: ourRequestToken ? ourRequestToken : "" };
	return header;
};
export default async function get(url, type = false, ourRequestToken = null) {
	const header = await getHeader(ourRequestToken);
	const commonLoginToken = await getCommonLoginToken();
	if (commonLoginToken && commonLoginToken.token) {
		// add token to url if it is not already there
		if (url.indexOf("?") === -1) {
			url = url + "?token=" + commonLoginToken.token;
		} else if (url.indexOf("token=") === -1) {
			url = url + "&token=" + commonLoginToken.token;
		}
	}
	return await axios.get(
		url,
		type ? header : { cancelToken: ourRequestToken ? ourRequestToken : "" }
	);
}
export async function delete_(url, type = false) {
	const header = await getHeader();
	const commonLoginToken = await getCommonLoginToken();
	if (commonLoginToken && commonLoginToken.token) {
		// add token to url if it is not already there
		if (url.indexOf("?") === -1) {
			url = url + "?token=" + commonLoginToken.token;
		} else if (url.indexOf("token=") === -1) {
			url = url + "&token=" + commonLoginToken.token;
		}
	}
	return await axios.delete(url, type ? header : {});
}
export async function post(url, props, type = false) {
	const header = await getHeader();
	const commonLoginToken = await getCommonLoginToken();

	if (commonLoginToken && commonLoginToken.token && !props.token) {
		// add token to props if it is not already there
		// if (props && props.token) {
		props.token = commonLoginToken.token;
		// }
	}
	return await axios.post(url, props, type ? header : {});
}

export async function put(url, props, type = false) {
	const header = await getHeader();
	const commonLoginToken = await getCommonLoginToken();
	if (commonLoginToken && commonLoginToken.token) {
		// add token to props if it is not already there
		// if (props && props.token) {
		props.token = commonLoginToken.token;
		// }
	}
	return await axios.put(url, props, type ? header : {});
}
